import CryptoJS from 'crypto-js'

export default (message, secret) => {
    const bytes = CryptoJS.AES.decrypt(message, secret);
    return bytes.toString(CryptoJS.enc.Utf8)
}



// WEBPACK FOOTER //
// ./src/utils/decrypt.js